import { API_URL } from "constants/ApiUrl";
import fetch from "../auth/FetchInterceptor";
const ApplicationService = {};

ApplicationService.getApplications = function () {
    let url = `${API_URL}/api/club/application`;

    return fetch({
        url: url,
        method: "get",
        headers: {
            "Content-Type": "application/json",
        },
    });
};

ApplicationService.getApplicationsAgents = function () {
    let url = `${API_URL}/api/agent/application`;

    return fetch({
        url: url,
        method: "get",
        headers: {
            "Content-Type": "application/json",
        },
    });
};

export default ApplicationService;
